import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function Landing() {
  const navigate = useNavigate();
  return (
    <div style={s.page}>
      <section style={s.hero}>
        <div style={s.tag}>✦ Agence Créative Digitale — Montréal</div>
        <h1 style={s.h1}>Dashboard<br/><em style={s.em}>Agence Ucreative inc.</em></h1>
        <p style={s.sub}>Sites web, identités visuelles, stratégies digitales. On transforme vos idées en expériences mémorables.</p>
        <div style={s.btns}>
          <button style={s.btnPrimary} onClick={() => navigate('/contact')}>Démarrer un projet</button>
          <button style={s.btnSecondary} onClick={() => navigate('/auth')}>Espace client</button>
        </div>
      </section>

      <div style={s.stats}>
        {[['48+','Projets livrés'],['100%','Clients satisfaits'],['5★','Note moyenne']].map(([n,l]) => (
          <div key={l} style={s.stat}>
            <div style={s.statNum}>{n}</div>
            <div style={s.statLabel}>{l}</div>
          </div>
        ))}
      </div>

      <section style={s.services}>
        <div style={s.sLabel}>Ce qu'on fait</div>
        <h2 style={s.sTitle}>Nos services</h2>
        <div style={s.grid}>
          {[
            ['01','🌐','Sites Web','Design sur mesure, performant et optimisé.'],
            ['02','✦','Identité Visuelle','Logo, charte graphique, direction artistique.'],
            ['03','📱','Applications','Web apps React, tableaux de bord, espaces clients.'],
            ['04','🚀','Stratégie Digitale','SEO, réseaux sociaux, présence en ligne.'],
          ].map(([num,icon,title,desc]) => (
            <div key={title} style={s.card}>
              <div style={s.cardNum}>{num}</div>
              <div style={s.cardIcon}>{icon}</div>
              <h3 style={s.cardTitle}>{title}</h3>
              <p style={s.cardDesc}>{desc}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}

const s = {
  page:        { background: '#080808', color: '#F0F0F0', minHeight: '100vh', paddingTop: '80px' },
  hero:        { minHeight: '90vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', textAlign: 'center', padding: '80px 40px 40px' },
  tag:         { display: 'inline-block', background: '#1a1a1a', border: '1px solid rgba(255,255,255,0.08)', borderRadius: '100px', padding: '6px 16px', fontSize: '0.8rem', color: '#888', marginBottom: '32px' },
  h1:          { fontSize: 'clamp(3rem,8vw,7rem)', fontWeight: 800, lineHeight: 1, letterSpacing: '-0.04em', marginBottom: '24px' },
  em:          { color: '#3b82f6', fontStyle: 'normal' },
  sub:         { fontSize: '1.1rem', color: '#888', maxWidth: '520px', lineHeight: 1.7, marginBottom: '48px' },
  btns:        { display: 'flex', gap: '16px', flexWrap: 'wrap', justifyContent: 'center' },
  btnPrimary:  { background: '#3b82f6', color: '#000', border: 'none', padding: '16px 36px', borderRadius: '100px', fontWeight: 700, fontSize: '1rem', cursor: 'pointer' },
  btnSecondary:{ background: 'transparent', color: '#F0F0F0', border: '1px solid rgba(255,255,255,0.08)', padding: '16px 36px', borderRadius: '100px', fontWeight: 600, fontSize: '1rem', cursor: 'pointer' },
  stats:       { background: '#111', borderTop: '1px solid rgba(255,255,255,0.08)', borderBottom: '1px solid rgba(255,255,255,0.08)', padding: '60px 40px', display: 'flex', justifyContent: 'center', gap: '80px', flexWrap: 'wrap' },
  stat:        { textAlign: 'center' },
  statNum:     { fontSize: '3rem', fontWeight: 800, color: '#3b82f6' },
  statLabel:   { color: '#888', fontSize: '0.85rem', marginTop: '4px' },
  services:    { padding: '100px 40px', maxWidth: '1200px', margin: '0 auto' },
  sLabel:      { fontSize: '0.75rem', letterSpacing: '0.15em', color: '#3b82f6', textTransform: 'uppercase', marginBottom: '16px' },
  sTitle:      { fontSize: 'clamp(2rem,4vw,3.5rem)', fontWeight: 800, letterSpacing: '-0.03em', marginBottom: '60px' },
  grid:        { display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(260px,1fr))', gap: '2px' },
  card:        { background: '#111', padding: '40px' },
  cardNum:     { fontSize: '0.75rem', color: '#888', marginBottom: '24px', letterSpacing: '0.1em' },
  cardIcon:    { fontSize: '2rem', marginBottom: '16px' },
  cardTitle:   { fontSize: '1.25rem', fontWeight: 700, marginBottom: '12px' },
  cardDesc:    { color: '#888', fontSize: '0.9rem', lineHeight: 1.7 },
};
